import { render } from "./OpeningHours.vue?vue&type=template&id=dc3f865a&scoped=true"
import script from "./OpeningHours.vue?vue&type=script&lang=js"
export * from "./OpeningHours.vue?vue&type=script&lang=js"

import "./OpeningHours.vue?vue&type=style&index=0&id=dc3f865a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc3f865a"]])

export default __exports__